import { render } from "./AdLead.vue?vue&type=template&id=982d87dc"
import script from "./AdLead.vue?vue&type=script&lang=js"
export * from "./AdLead.vue?vue&type=script&lang=js"

import "./AdLead.vue?vue&type=style&index=0&id=982d87dc&lang=css"

import exportComponent from "C:\\pythonproject0\\tkrforntend\\tkrforntend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__